'use strict';
// @flow

import $ from 'jquery';
import get from 'lodash/get';

type User = {
  name: string,
  email: string,
  password: string
}
const emailValidationRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function LoginDialogController($state, $scope, $mdDialog, Auth) {
  'ngInject';

  $scope.user = {
    name: '',
    email: '',
    password: '',
    demoEmail: ''
  };
  $scope.errors = {
    login: undefined
  };
  $scope.submitted = false;
  $scope.isDemoInput = false;
  $scope.isDemoRequested = false;
  $scope.demoEmail = null;
  $scope.demoIsValidEmail = false;

  $scope.login = form => {
    $scope.submitted = true;

    if(form.$valid) {
      Auth.login({
        email: $scope.user.email,
        password: $scope.user.password
      })
        .then(() => {
          // Logged in, redirect to home
          $state.go('app.welcome');
          $mdDialog.hide();
        })
        .catch(err => {
          $scope.errors.login = err.message;
        });
    }
  };

  $scope.enterDemo = () => {
    $scope.isDemoInput = true;
  };
  $scope.exitDemo = () => {
    $scope.isDemoInput = false;
  };
  $scope.verifyEmail = () => {
    $scope.demoIsValidEmail = $scope.user.demoEmail && $scope.user.demoEmail.length > 0 && emailValidationRegex.test($scope.user.demoEmail);
  };

  $scope.activateDemo = () => {
    if(!$scope.demoIsValidEmail) {
      return;
    }

    $scope.isLoading = true;

    Auth.requestDemoAccount($scope.user.demoEmail)
      .then(() => {
        $scope.isLoading = false;
        $scope.isDemoInput = false;
        $scope.isDemoRequested = true;
      })
      .catch(err => {
        $scope.errors.login = get(err, 'data.message', err.message);
      });
  };
}

export default class LoginController {
  $state
  $mdDialog
  $timeout

  /*@ngInject*/
  constructor($state, $mdDialog, $timeout) {
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$timeout = $timeout;
  }

  $onInit = () => {
    this.$timeout(() => this.promptLogin(), 600);
  }

  promptLogin = () => {
    this.$mdDialog
      .show({
        controller: LoginDialogController,
        template: require('./login.dialog.html'),
        parent: $(document.body),
        clickOutsideToClose: false,
        fullscreen: false,
        escapeToClose: false,
        hasBackdrop: false
      })
      .then(
        image => {},
        () => {
          // Cancelled
        }
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js